import type { ReactNode } from 'react';
import { StatusChip } from '@eis/patterns';
import { kindToken } from '../model/leads';
import type { LeadStatus } from '../model/types';

/**
 * A lead's status: the TENANT's name as the label, the PLATFORM's kind as the colour
 * (SDD-013 §8.1.1). The console never translates a status code — `Angebot erstellt` is what the
 * lifecycle asset calls it — and never colours by code either: two tenants' `offered` and
 * `quoted` are both OPEN, and OPEN is what the theme token answers for.
 */
export function LeadStatusChip({ status }: { readonly status: LeadStatus | undefined }): ReactNode {
  const kind = (status?.kind ?? '').replace('STATUS_KIND_', '');
  const label = status?.name !== undefined && status.name !== '' ? status.name : (status?.code ?? '—');
  return <StatusChip status={kindToken(kind)} label={label} />;
}
